import BaseApi from './baseApi'
import storeId from './_storeId'

export default class ShippingSetting extends BaseApi {
  uri = `/api/v1/stores/${storeId()}/shipping-setting`
}
